import { render, staticRenderFns } from "./listPassCards.vue?vue&type=template&id=22548720"
import script from "./listPassCards.vue?vue&type=script&lang=js"
export * from "./listPassCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports